function WindowTopBar({ title, bgColor, borderColor, children }) {
  const style = {
    backgroundColor: bgColor,
    borderBottom: `8px solid ${borderColor}`,
  };
  return (
    <>
      <div
        className="window-top-bar fs-3 p-2 d-flex align-items-center justify-content-between"
        style={style}
      >
        <h5 className="window-text d-inline ms-2">{title}</h5>
        <div className="fs-5 d-flex align-items-center justify-content-end">
          <i className="bx bx-minus window-icon align-self-end p-1 mx-1"></i>
          <i className="bx bx-square-rounded window-icon p-1 mx-1"></i>
          <i className="bx bx-x window-icon p-1 mx-1"></i>
        </div>
      </div>
      {children}
    </>
  );
}

export default function Window({
  title,
  barBgColor,
  bgColor,
  borderColor,
  children,
}) {
  return (
    <div
      className="shadow"
      style={{
        backgroundColor: bgColor,
        border: `8px solid ${borderColor}`,
        borderRadius: '10px',
      }}
    >
      <WindowTopBar
        title={title}
        bgColor={barBgColor}
        borderColor={borderColor}
      >
        <div>{children}</div>
      </WindowTopBar>
    </div>
  );
}
